// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__kGlrE"};